  /**
 * INTEGRAÇÃO G4FLEX - FORMATO ESTRITO DO PRINT (CORRIGIDO)
 */

  // 1. Ouvinte do Evento (O "Gatilho")
document.addEventListener('wpcf7mailsent', function(event) {
    console.log("Form Submission Detected. Initializing...");

    // Capturamos o formulário exato que disparou o evento
    const $currentForm = jQuery(event.target);

    // CHAMADA IMPORTANTE: Passamos o formulário para a função
    handleIntegrations($currentForm); 
}, false);

// 2. Função de Integração (O "Envio")
async function handleIntegrations($form) {
    // Agora o $form não será mais 'undefined'
    const rawName  = $form.find('[name="nome"]').val();
    const rawEmail = $form.find('[name="email"]').val();
    const rawPhone = $form.find('[name="telefone"]').val().replace(/\D/g, '');

    // Payload seguindo fielmente a estrutura da sua imagem técnica
    const leadPayload = {
        "responsibleLogin": "adm",
        "name": rawName,
        "email": rawEmail,
        "phone": "55" + rawPhone,
        "origem_lead": "LP Costamare",
        "empreendimento": "Conviver Costamare",
        "stageId": 1,
    };

    try {
        await jQuery.ajax({
            url: crmSettings.leadBaseUrl + crmSettings.recordTypeId,
            type: 'POST',
            contentType: 'application/json',
            headers: { "Authorization": "Bearer " + crmSettings.token },
            data: JSON.stringify(leadPayload)
        });

        console.log("✅ Sucesso no formato do print! Lead Enviado");

    } catch (error) {
        console.error("❌ Erro na integração.");
        if (error.responseJSON) {
            console.log("Mensagem do CRM:", error.responseJSON);
        }
    }
}
